import React, { Fragment, useState, useEffect } from 'react'
import "./post.css";
import { MoreHoriz } from "@material-ui/icons";
import { faTrash, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import EditCommentButton from './../../../EditCommentButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../../../styles/colors';
import { ConfirmJsMessage } from '../../../../helpers.js'
import { getName, getAvtar }  from "./../utils"
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CommentForm from "../share/CommentForm";


export default function Comment(props) {

  const { isMobile, comment, passParent, deleteItem, onDeleteComment, onSaveComment } = props;
  const [anchorCommentEl, setAnchorCommentEl] = useState(null);
  const [item, setItem] = useState({})

  useEffect(() => {
    setItem(comment)
  }, [comment])
  
  const handleCommentClick = (event, comment) => {
    setAnchorCommentEl(event.currentTarget);
  }

  const handleCommentClose = () => {
    setAnchorCommentEl(null);
  }

  const deleteComment = (id) => {
    handleCommentClose()
	if (ConfirmJsMessage(`All informations related with this comment will be lost. Are you sure you want to delete the comment? `)) {
		deleteItem(id, 'comment').then(() => {
            onDeleteComment(id);
        });
	}
  }

  return (
    <div className="commentWrapper">
        <div className="postTop">
          <div className="postTopLeft">
            { item && item.user && item.user.length > 0 &&
              getAvtar(item.user[0])
            }
            <div class='comment'>
              <div className="commentMessage">
                {item && item.user && item.user.length && getName(item.user[0])}
                <div className="commentDesc">{item.description}</div>
              </div>
              <div className={isMobile ? "mobileCommentMore": "commentMore"}>
                  <FontAwesomeIcon  icon={faEllipsisH} 
                        style={{ color: COLORS.orange, cursor: 'pointer' }} size={"2x" } onClick={(e) => handleCommentClick(e, comment)} />
                    <Menu
                            id="comment-menu"
                            anchorEl={anchorCommentEl}
                            keepMounted
                            open={Boolean(anchorCommentEl)}
                            onClose={handleCommentClose}
                    >
                      <MenuItem onClick={handleCommentClose}>
                          <EditCommentButton onSaveComment={(res, isNew) => {
                            setItem({
                             ...item,
                             ...res
                            })
                            onSaveComment(res, isNew);
                          }} isMobile = {isMobile } item={comment}  />
                      </MenuItem>
                      <MenuItem onClick={() => deleteComment(item._id)}>
                      <span
                          className="link"
                          style={{float:'right', color: COLORS.red, marginLeft: isMobile && 10}}>
                          <FontAwesomeIcon size={isMobile && "2x" } icon={faTrash} title={'Delete'}
                            style={{marginRight: 5, color: COLORS.red}}/>Delete
                        </span>
                      </MenuItem>
                    </Menu>
                </div>
              </div>
          </div>
        </div>
      </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/social/shared/post/Comment.jsx